import React from "react";
import "../../simplelocker.css";
import "../../index.css";
import { Link, useNavigate } from "react-router-dom";
import ProfileImg from "../../images/images/profile.png";
import { useSelector } from "react-redux";
const Header2 = () => {
  const isAuthenticated = useSelector((state) => state.user);
  return (
    <div>
      <header className="header2 mb-5">
        <div className="row my-3">
          <div className="prof-sett">
            <div className="col-lg-6">
              <div
                className="main-heading2 text-capitalize"
                style={{ color: "#012267", fontSize: "1000" }}
              >
                <h1>Welcome Back {isAuthenticated.name}!</h1>
              </div>
            </div>
            <div className="col-lg-6 ">
              <div className="prof-wrap">
                <div className="det-prof">
                  <div className="name-wrap">
                    <h5 className="mb-0 text-capitalize">
                      {isAuthenticated.name}
                    </h5>
                    <p>{isAuthenticated.email}</p>
                  </div>
                </div>
                <div className="prof-img">
                  {isAuthenticated.image ? (
                    <Link to="/profile">
                      <div className="img-profile-wrap">
                        <img
                          src={isAuthenticated?.image}
                          alt="profile"
                          onError={(e) =>
                            (e.target.src = "/placeholder.png")
                          }
                          style={{
                            height: "50px",
                            width: "50px",
                            borderRadius: "5px",
                          }}
                        />
                      </div>
                    </Link>
                  ) : (
                    <Link to="/profile">
                      <img
                        src={ProfileImg}
                        onError={(e) => (e.target.src = "/placeholder.png")}
                        alt=""
                      />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};
export default Header2;
